<template>
  <svg
    width="14px"
    height="20px"
    viewBox="0 0 14 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Dashboard-DNA"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="ic_wellbeing" fill="#C1DDDC" fill-rule="nonzero">
        <path
          id="wellness"
          d="M7,7 C6.03333333,7 5.20833333,6.65833333 4.525,5.975 C3.84166667,5.29166667 3.5,4.46666667 3.5,3.5 C3.5,2.53333333 3.84166667,1.70833333 4.525,1.025 C5.20833333,0.341666667 6.03333333,0 7,0 C7.96666667,0 8.79166667,0.341666667 9.475,1.025 C10.1583333,1.70833333 10.5,2.53333333 10.5,3.5 C10.5,4.46666667 10.1583333,5.29166667 9.475,5.975 C8.79166667,6.65833333 7.96666667,7 7,7 Z M7,20 L1,14 C0.666666667,13.6666667 0.416666667,13.2916667 0.25,12.875 C0.0833333333,12.4583333 0,12 0,11.5 C0,10.5166667 0.3375,9.6875 1.0125,9.0125 C1.6875,8.3375 2.51666667,8 3.5,8 C3.98333333,8 4.42916667,8.09166667 4.8375,8.275 C5.24583333,8.45833333 5.61666667,8.71666667 5.95,9.05 L7,10.1 L8.05,9.05 C8.38333333,8.71666667 8.75416667,8.45833333 9.1625,8.275 C9.57083333,8.09166667 10.0166667,8 10.5,8 C11.4833333,8 12.3125,8.3375 12.9875,9.0125 C13.6625,9.6875 14,10.5166667 14,11.5 C14,12 13.9166667,12.4583333 13.75,12.875 C13.5833333,13.2916667 13.3333333,13.6666667 13,14 L7,20 Z"
        ></path>
      </g>
    </g>
  </svg>
</template>
